<a
  [routerLink]="path()"
  routerLinkActive
  #rla="routerLinkActive"
  [routerLinkActiveOptions]="{ exact: exact() }"
  (click)="activated.emit()"
  class="items-center px-3 py-2 rounded-lg font-semibold text-sm transition-colors"
  [class.flex]="mobile()"
  [class.hidden]="!mobile()"
  [class.md:flex]="!mobile()"
  [class.text-amcom-purple]="rla.isActive"
  [class.bg-purple-50]="rla.isActive"
  [class.text-slate-600]="!rla.isActive && !mobile()"
  [class.text-slate-700]="!rla.isActive && mobile()"
  [class.hover:bg-slate-100]="!rla.isActive"
  [class.hover:text-slate-900]="!rla.isActive && !mobile()"
  ariaCurrentWhenActive="page"
  [attr.aria-label]="ariaLabel()"
>
  <i class="fas mr-2" [class]="icon()"></i>{{ label() }}
</a>
